import React from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_UI_PICTURE_LARGE,
    getActiveProject,
    OBS_PICTS,
    UI_LIST_LIMIT,
} from "../prodect/ProsConnect";
import {
    renderNoCapacity,
    AddObsButton,
    isListView,
    renderItemByType
} from '../prodect/ProsCommonUi';

import {
    Accordion,
} from 'react-accessible-accordion';

import {
    STR_NO_VALUE,
    ATTR_OBJ_TYPE,
    ATTR_REPORT_INDEX,
    ATTR_OBJ_ID,
    OBJ_TYPE_ITM_OBS
} from "../prodect/ProsConnect";
import {getCopyMoveManager} from "../prodect/CopyMoveManager";
import {featureEnabled, FEAT_SHOW_OBS_INFO} from "../prodect/ProsConnect";
import ProsObsHistoryListing from "../prodect/ProsObsHistoryListing";
import ReportSearchMenu from "../prodect/ReportSearchMenu";
import ProsObs from "../prodect/ProsObs";
import ProsObsDependencyListing, {
    renderThisDependsOnForHistory
} from "../prodect/ProsObsDependencyListing";
import {rememberLastSelectedReportId} from "../prodect/ProsEditObs";
import BasicButton from "../components/BasicButton";
import Spacer from "../components/Spacer";
import {BasicModalDismiss} from "../components/BasicModal";
import TabsNavigation from "../components/TabsNavigation";
import {renderWithRestoreControls} from "./ProjectDeletedDataRestore";

export default class RenderReport extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedItem: undefined,
            refreshCounter: 0,
            restoreList: [],
            selectedObsHistoryObjId: null,
            showRelationListingObjId: this.props.report[ATTR_OBJ_ID] || null,
            forceZitemIds: [null, null] //used for z-index issues in list view
        }
        this.itemSelected=this.itemSelected.bind(this)
        this.renderHistoryItemCallback=this.renderHistoryItemCallback.bind(this)
    }

    refreshUi() {
        this.setState({refreshCounter: this.state.refreshCounter + 1})
    }

    toggleOpenReport(report) {
        report.ui_isOpen = !report.ui_isOpen
        if (report.ui_isOpen) {
            rememberLastSelectedReportId(report[ATTR_OBJ_ID])
        }
        this.refreshUi()
        this.props.refreshParentUi()
    }

    itemSelected(item, _callback) {
        if (this.props.hasOwnProperty('itemSelected')) {
            this.props.itemSelected(item)
        } else {
            prosConnect.prosLog('ERR no props.itemSelected', item)
        }
        // set last selected item info
        this.setState({
                selectedItem: item
            }, ()=> {
            if(typeof _callback === 'function') _callback()
        })
    }

    //0 is report ID, 1 is obs id
    setForceZitem(idsArr){
        if(!isListView()) return
        this.setState({
            forceZitemIds: idsArr
        })
    }

    toggleShowObsHistory(obs) {
        const newObsHistoryObjId = this.state.selectedObsHistoryObjId === obs[ATTR_OBJ_ID] ? null : obs[ATTR_OBJ_ID]
        if (newObsHistoryObjId) {
            this.setState({
                selectedObsHistoryObjId: newObsHistoryObjId,
                showRelationListingObjId: null
            })
        } else {
            this.hideObsHistory()
        }
        BasicModalDismiss()
    }

    closePicturesAndVideos(obs){
        if (obs[OBS_PICTS]) {
            obs[OBS_PICTS].forEach(pict => pict[ATTR_UI_PICTURE_LARGE] = false)
        }
    }

    hideObsHistory(){
        this.setState({
            selectedObsHistoryObjId: null
        })
    }

    renderHistoryItemCallback(item){
        return this.render(item)
    }

    accordionHeaderClassToggle(obs) {
        obs.ui_isOpen = !obs.ui_isOpen;
        // When closing OBS, disable OBS history if active
        if (!obs.ui_isOpen){
            if (this.state.selectedObsHistoryObjId) {
                this.hideObsHistory();
            }
            this.closePicturesAndVideos(obs);
        }
    }

    isReportNumbered(obj){
        return obj && obj.hasOwnProperty(ATTR_REPORT_INDEX) && obj[ATTR_REPORT_INDEX] !== STR_NO_VALUE
    }

    getDragState() {
        return getCopyMoveManager().getRearrangeMode()
    }

    toggleObsOpenClosed(obs){
        if(this.props.isObsSidePanel || (obs.ui_isHistoryItem && !obs.ui_removed)) return
        this.itemSelected(obs)
        this.accordionHeaderClassToggle(obs)
    }

    renderObs(obs) {
        if (!obs.obsObjList) {
            prosConnect.prosLogDt("missing OBS obsObjList");
            return null
        }
        //For history listing, always open but allow opening for restore removed listing
        const isObsOpen = obs.ui_isOpen || (obs.ui_isHistoryItem === true && !obs.ui_removed)
        const focusId = isObsOpen ? <span id= {"focus-" + obs[ATTR_OBJ_ID]} className={"focus-target"} />  : null
        return <Accordion
                key={obs.obj_id + '__ro'}
                draggable={isObsOpen ? null : this.getDragState() && !obs.ui_isHistoryItem}
                onDragStart={e => getCopyMoveManager().onDragStart(e, obs)}
                onDragOver={e => getCopyMoveManager().onDragOver(e, obs)}
                onDragLeave={e => getCopyMoveManager().onDragLeave(e)}
                onDrop={e => getCopyMoveManager().onDrop(e, obs)}
                className={"list-view-item"
                    + (isObsOpen ? " opened" : "")
                    + (obs.ui_removed ? " restore-listing" : "")
                    + (this.state.forceZitemIds[1] === obs[ATTR_OBJ_ID] ? " force-z" : "")
                }
                onClick={(evt) => {
                    evt.stopPropagation()
                    this.toggleObsOpenClosed(obs)
                }}
            >
            {focusId}
            <ProsObs
                obs={obs}
                report={this.props.report}
                reportParent={this}
                isOpen={isObsOpen}
                isSidePanel={this.props.isObsSidePanel}
                toggleSettingsDropdown={isOpen => {
                    this.setForceZitem(isOpen ? [this.props.report[ATTR_OBJ_ID], obs[ATTR_OBJ_ID]] : [null, null])
                }}
                isReordering={this.getDragState()}
            />
            {this.renderObsFooter(obs)}
        </Accordion>
    }

    renderObsFooter(obs) {
        if(!obs.ui_isOpen || obs.ui_isHistoryItem){
            return null
        }
        const everyObs = prosConnect.getActiveProject().getObservations()
        const hasMoreThanOneObs = everyObs.length > 1
        return <footer
            onClick={(evt) => {
                evt.stopPropagation()
            }}
            className={"obs-footer"}
        >
            {this.renderTabsNav(obs, hasMoreThanOneObs)}
            {hasMoreThanOneObs ? this.renderObsDependencies(obs, everyObs) : null}
            {this.renderObsHistoryElement(obs)}
        </footer>
    }

    renderObsHistoryElement(obs) {
        if (this.state.selectedObsHistoryObjId !== obs[ATTR_OBJ_ID]) {
            return null
        }
        return <div
            onClick={(evt) => {
                evt.stopPropagation()
            }}
            className={"list-view history-listing margin-top"}
        >
            <ProsObsHistoryListing
                obs={obs} selectedObsHistoryObjId={this.state.selectedObsHistoryObjId}
                renderItemCallback={this.renderHistoryItemCallback}
            />
            {renderThisDependsOnForHistory(obs, prosConnect.getActiveProject().getObservations())}
        </div>
    }

    renderObsDependencies(obs, everyObs) {
        if(obs.ui_isHistoryItem){
            return null
        }
        return <ProsObsDependencyListing
            obs={obs}
            everyObs={everyObs}
            showListing={this.props.report[ATTR_OBJ_ID] === this.state.showRelationListingObjId
                || this.state.showRelationListingObjId === obs[ATTR_OBJ_ID]}
            onSelectObs={(newObsId)=>{
                if(this.props.isObsSidePanel) this.props.onSelectObs(newObsId)
            }}
        />
    }

    renderTabsNav(obs, hasMoreThanOneObs){
        let linkValues = []
        if(hasMoreThanOneObs) {
            linkValues.push({
                value: '__' + obs[ATTR_OBJ_ID],
                text: 'Yhteydet',
                selected: this.props.report[ATTR_OBJ_ID] === this.state.showRelationListingObjId
                    || this.state.showRelationListingObjId === obs[ATTR_OBJ_ID]
            })
        }
        if (featureEnabled(FEAT_SHOW_OBS_INFO) || !obs.ui_isHistoryItem) {
            linkValues.push({
                value: obs[ATTR_OBJ_ID],
                text: 'Muutosloki',
                selected: this.state.selectedObsHistoryObjId === obs[ATTR_OBJ_ID]
            })
        }
        const setView =(val)=> {
            if (val.indexOf('__') > -1) {
                val = val.replace('__', '')
                const showRelationListingObjId = (this.state.showRelationListingObjId === val ? null : val)
                this.setState({
                    showRelationListingObjId: showRelationListingObjId
                })
                this.hideObsHistory()
            } else {
                this.toggleShowObsHistory(obs)
            }
        }
        if(linkValues.length < 1){
            return null
        }
        return <TabsNavigation
            values={linkValues}
            callback={(val)=> setView(val)}
            className={"margin-top"}
            position={"right"}
        />
    }

    renderReportDropdown(report, isReportSelected) {
        if(report.ui_isHistoryItem) {
            return null// Do not show menu icon for deleted/history reports
        }
        return <ReportSearchMenu
            report={report}
            gotoPage={this.props.gotoPage}
            notif={this.props.notif}
            icon={isReportSelected ? "ellipsis-v_color-main" : null}
            openDropdownCallback={()=> this.setForceZitem([report[ATTR_OBJ_ID], null])}
            closeDropdownCallback={()=> this.setForceZitem([null, null])}
        />
    }

    renderOpenAllButton(report, isReportOpened){
        let reportHasObs = report.obsList.find( obj => obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS)
        if(!isReportOpened) return null
        if(!reportHasObs || (report.obsList.length <= 1 || report.obsList.length > UI_LIST_LIMIT)) return null
        let everyObs = report.obsList.filter(obj => obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS)
        let everyObsIsOpen = everyObs.every(obs => obs.ui_isOpen)
        return <BasicButton
            icon={everyObsIsOpen ? "close-all" : "open-all"}
            action={() => {
                this.openAllInReport(everyObs, everyObsIsOpen);
            }}
            hilite
            title={everyObsIsOpen ? "Sulje kaikki" : "Avaa kaikki"}
            selected={everyObsIsOpen}
            size={"md"}
        />
    }

    renderReport(report) {
        // todo Sampo: miksi raportin reunukset ei näytä että se voidaan dragata ?
        // todo Sampo : tarvitaanko data-tooltip ( numeroitua raporttia ei voi siirtää ) - en näe sitä missään ?
        let isReportOpened = report.ui_isOpen
        let isReportSelected = prosConnect.getActiveProject().isReportSelected(report[ATTR_OBJ_ID])
        let isDraggable = !isReportOpened && this.getDragState() && !this.isReportNumbered(report)
        return <div
                key={report.obj_id + '__rr'}
                draggable={isDraggable || null}
                onDragStart={(e) => getCopyMoveManager().onDragStart(e, report)}
                onDragOver={(e) => getCopyMoveManager().onDragOver(e, report)}
                onDragLeave={(e) => getCopyMoveManager().onDragLeave(e)}
                onDrop={(e) => getCopyMoveManager().onDrop(e, report)}
                className={"report-item"
                    + (isReportOpened ? " opened" : "")
                    + (this.state.forceZitemIds[0] === report[ATTR_OBJ_ID] ? " force-z" : "")
                    + (isDraggable ? " drag-element" : "")
                }
                data-tooltip={!isDraggable && !isReportOpened && this.getDragState()
                    ? "Numeroitua raporttia ei voi siirtää" : null}
                onClick={(evt) => {
                    evt.stopPropagation()
                    if(!report.ui_removed) this.toggleOpenReport(report)
                }}
            >
            <span id={'hreftagup' + report.obj_id} className={"hreftag-up"} />
            <header
                tabIndex={0}
                className={"report-header valign-center"}
            >
                <h2 className={"report-title"}>
                    {prosConnect.getReportInfo(report)}
                </h2>
                {this.renderReportControls(report, isReportOpened)}
            </header>
            {isReportOpened ? <section className={"list-view-item-content"}
                   onClick={(evt) => {
                       evt.stopPropagation()
                   }}
                >
                {this.renderReportObservations(report)}
                {this.renderNewObsButton(report, isReportSelected)}
            </section> : null}
            <span id={"hreftagdown" + report[ATTR_OBJ_ID]} className={"hreftag-down"}/>
        </div>
    }

    renderReportControls(report, isReportOpened){
        if(this.getDragState()) return null
        return <div className={"element-set"}>
            {!isReportOpened ? this.renderReportTitleIcons(report.obsList.length) : null}
            <div className={"btn-set"}>
                {(isReportOpened ? this.renderPageScrollButtons(report) : null)}
                {this.renderOpenAllButton(report, isReportOpened)}
                {this.renderReportDropdown(report, isReportOpened)}
            </div>
        </div>
    }

    renderReportTitleIcons(amount){
        const icontext = amount === 0 ? 'Ei kirjauksia' : amount === 1 ? 'kirjaus' : 'kirjausta'
        return <div className={"text-xs valign-center"}>
            {amount > 0 ? amount  : null} {icontext}
        </div>
    }

    renderPageScrollButtons(report){
        if(report.ui_removed) return null
        if(report.obsList.length < 10 && report.obsList.filter(obj => obj.ui_isOpen).length < 1) return;
        return <>
            <BasicButton
                title={"Siirry listan loppuun"}
                icon={"arrow-down"}
                action={()=> {
                    this.scrolltoElementById('hreftagdown' + report.obj_id)
                }}
                hilite={true}
                className={"dom-hide dom-show_md"}
                size={"md"}
            />
            <BasicButton
                title={"Siirry listan alkuun"}
                icon={"arrow-up"}
                action={()=> {
                    this.scrolltoElementById('hreftagup' + report.obj_id);
                }}
                hilite={true}
                className={"dom-hide dom-show_md"}
                size={"md"}
            />
            <BasicButton
                title={"Siirry sivun alkuun"}
                icon={"arrow-end-up"}
                action={()=> {
                    this.scrolltoElementById('pageTop');
                }}
                hilite={true}
                className={"dom-hide dom-show_lg"}
                size={"md"}
            />
        </>
    }

    scrolltoElementById(id){
        const el = document.getElementById(id)
        if(el) {
            el.scrollIntoView()
        }
    }

    renderNewObsButton(report, isReportSelected) {
        if (!prosConnect.hasPermissionTo("addContent", undefined, undefined)) {
            return
        }
        if (report.ui_removed || report.ui_isHistoryItem){
            return null
        }
        if (getActiveProject().hasCapacityToAddItems()) {
            if(!isReportSelected) return null
            return <div className={"padding-top"}>
                <AddObsButton
                    report={report.obj_id}
                />
            </div>
        }
        return renderNoCapacity('kirjausta')
    }

    renderLocationPictures(item) {
        if (item[ATTR_OBJ_TYPE] === prosConnect.OBJ_TYPE_LST_PROJ_PICT && item.obsList.length > 0) {
            return item.obsList.map(itm=> {
                return renderItemByType(itm, false, this.getDragState(), this)
            })
        }
        return null
    }

    openAllInReport(everyObs, everyObsIsOpen) {
        everyObs.forEach(obs => obs.ui_isOpen = !everyObsIsOpen)
        this.refreshUi()
    }

    renderReportObservations(report) {
        if (report.hasOwnProperty('obsList')) {
            if(!report.obsList.length) return <Spacer label={"Ei kirjauksia"} line />
            return <div className={"list-view" + (this.props.listReversed ? " content-reversed" : "")}>
                {report.obsList.map(
                    (reportItem) => {
                        return this.render(reportItem)
                    }
                )}
            </div>
        }
        return null
    }

    renderSearchReport(report) {
        return <div key={report.obj_id} className={"report-item search-list-view-item opened"}>
            <span id={'hreftagup' + report.obj_id} className={"hreftag-up"} />
            <header className={"report-header valign-center"}>
                <h2 className={"report-title margin-left"}>
                    {prosConnect.getReportInfo(report)}
                </h2>
                <div className={"btn-set"}>
                    {this.renderPageScrollButtons(report)}
                    {this.renderOpenAllButton(report, true)}
                    {this.renderReportDropdown(report, true)}
                </div>
            </header>
            <section className={"list-view-item-content"}>
                {this.renderReportObservations(report)}
            </section>
            <span id={"hreftagdown" + report[ATTR_OBJ_ID]} className={"hreftag-down"}/>
        </div>
    }

    render(subItem, obsAuthor) {
        let item = subItem || this.props.report
        const type = prosConnect.renderType(item)
        let elem = null
        switch (type) {

            case 'srch_lst':
                return this.renderSearchReport(item)

            case 'loc_pictures':
                return this.renderLocationPictures(item)

            case 'report':
                elem = this.renderReport(item)
                break

            case 'obs':
                elem = this.renderObs(item)
                break

            default:
                return renderItemByType(item, obsAuthor, this.getDragState(), this)
        }
        if(item.ui_removed){
            return renderWithRestoreControls(elem, item, this)
        }
        return elem
    }
}